/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Final step of Labels Import wizard
 *
 * @author Anton Panasenko
 * @version 1.3.1
 * @since 1.3.0
 */

import { Fragment } from 'react';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectLabelsImportTranslation } from '../../../modules/internationalization/intSelectors';
import { ILabelsImportTranslation } from '../../../modules/internationalization/types/wizards/labelsImport';
import { IRootReducer } from '../../../reducers/rootReducer';
import { ELabelsImportLabelsValidationStatus } from '../labelsImportConstants';
import { ILabelsImportLabelsValidationInfo } from '../labelsImportReducer';
import { makeSelectLabelsImportLabelsValidationInfo } from '../labelsImportSelectors';
import LabelsImportValidationStatus from './LabelsImportFileValidation/LabelsImportValidationStatus';
import LabelsImportTable from './LabelsImportTable/LabelsImportTable';


export type TLabelsImportStepFinal = IConnectedProps;

export const LabelsImportStepFinal = (props: TLabelsImportStepFinal) => {
    const renderFinalStep = () => {
        switch (props.labelsValidationInfo.status) {
            case ELabelsImportLabelsValidationStatus.PREPARING:
            case ELabelsImportLabelsValidationStatus.READY:
            case ELabelsImportLabelsValidationStatus.RUNNING:
                return <LabelsImportValidationStatus
                    labelsImportTranslation={props.labelsImportTranslation}
                    labelsValidationInfo={props.labelsValidationInfo}
                />
            case ELabelsImportLabelsValidationStatus.COMPLETED:
            case ELabelsImportLabelsValidationStatus.INTERRUPTED:
                return <LabelsImportTable
                    labelsImportTranslation={props.labelsImportTranslation}
                    labelsValidationInfo={props.labelsValidationInfo}
                />
            default:
                return <Fragment />
        }
    }

    return (
        <Fragment>
            { renderFinalStep() }
        </Fragment>
    )
}

interface IConnectedProps {
    labelsValidationInfo: ILabelsImportLabelsValidationInfo;
    labelsImportTranslation: ILabelsImportTranslation;
}

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    labelsValidationInfo: makeSelectLabelsImportLabelsValidationInfo(),
    labelsImportTranslation: makeSelectLabelsImportTranslation(),
});

export default connect(mapStateToProps)(LabelsImportStepFinal)
